export function ExtremeMeasures() {
  
  function render() {
    return /*html*/`
                              <!-- Grid -->
                              <div class="grid sm:grid-cols-12 gap-y-1.5 sm:gap-y-0 sm:gap-x-5">
                                <div class="sm:col-span-4 xl:col-span-3 2xl:col-span-2">
                                  <label class="sm:mt-2.5 inline-block text-sm text-gray-500 dark:text-neutral-500">
                                    Force Log out
                                  </label>
                                </div>
                                <!-- End Col -->
                                <div class="sm:col-span-8 xl:col-span-8">
                                  <button 
                                  aria-haspopup="dialog" aria-expanded="false" aria-controls="all-session-logout-modal" data-hs-overlay="#all-session-logout-modal" data-hs-overlay-options='{
                                    "isClosePrev": false
                                  }'
                                  type="button" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-red-500 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-50 dark:bg-neutral-800 dark:border-neutral-700 dark:text-red-500 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700">
                                    Log out from all devices
                                  </button>
                                  <p class="mt-2 text-sm text-gray-500 dark:text-neutral-500">
                                    It would log your account out from all the device & browser sessions. Use it if you feel your account is compromised for some reason and reset the password.
                                  </p>
                                </div>
                                <!-- End Col -->
                              </div>
                              <!-- End Grid -->
                            `;
  }

  return { render };
}